export default {
  dismiss(sm) {
    sm.commit("dismissed", true);
    sm.commit("dismissedAt", Date.now());
  },

  undismiss(sm) {
    sm.commit("dismissed", false);
    // Keep dismissedAt for expiration tracking
  },

  open(sm) {
    sm.commit("isOpen", true);
  },

  close(sm) {
    sm.commit("isOpen", false);
  },

  toggle(sm) {
    sm.commit("isOpen", !sm.state.isOpen);
  },

  startLoading(sm) {
    sm.commit("isLoading", true);
    sm.commit("isError", false);
    sm.commit("errorMessage", "");
  },

  loadSuccess(sm) {
    sm.commit("isLoading", false);
    sm.commit("hasData", true);
  },

  loadError(sm, errorMessage) {
    sm.commit("isLoading", false);
    sm.commit("isError", true);
    sm.commit("errorMessage", errorMessage);
  },

  retry(sm) {
    sm.commit("hasData", false);
    sm.commit("isError", false);
  },
};
